import { MedlemskapstypeFromBackend } from './medlemskapAPI';
import { PersonalInformation } from '../types/PersonalInformation';
import { ApiResource } from './ApiResource';
import { API_BASE_URL } from './apiUtils';

export interface BliMedlemSessionInitInput {
    hovedmedlem: PersonalInformation;
    partner?: PersonalInformation;
    barn?: PersonalInformation[];
    medlemskapstype: MedlemskapstypeFromBackend;
    amountInNorwegianOre: number;
    description: string;
    discountCode: string;
}

export interface VippsSessionResponse {
    token: string;
    checkoutFrontendUrl: string;
    paymentReference: string;
}

export const startBliMedlemSession = async (
    data: BliMedlemSessionInitInput
): Promise<ApiResource<VippsSessionResponse>> => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/StartSession`, {
            headers: { 'Content-Type': 'application/json' },
            method: 'POST',
            body: JSON.stringify(data),
        });
        if (!response.ok) {
            return { status: 'error' };
        }
        return {
            status: 'ok',
            data: (await response.json()) as VippsSessionResponse,
        };
    } catch (error) {
        return { status: 'error' };
    }
};
